/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import Sidebar from "components/sidebar/sidebar";
import { t } from "i18n";
import styles from "./sidebar.module.css";

type MenuSidebarProps = {
  isBannerPresent: boolean;
  isDesktopSizeViewport: boolean;
};

const MenuSidebar: React.SFC<MenuSidebarProps> = ({ isBannerPresent, isDesktopSizeViewport }) => {
  if (isDesktopSizeViewport) return null;
  return (
    <div>
      <Sidebar isBannerPresent={isBannerPresent}>
        <h3 className={styles["sidebar-title"]}>{t("menu.sidebar.title")}</h3>
      </Sidebar>
    </div>
  );
};

export default MenuSidebar;
